export default "__VITE_ASSET__$C8rb4mP__"